import type { ErrorConstants } from '@/types/services/utils/axios.type.ts';

const responseConstant: ErrorConstants = {
  /* Add error_keys to map with translations apiResponse */
  expired_token_error_key: 'expiredTokenErrorKey',
  invalid_credentials_error_key: 'invalidCredentialsErrorKey',
  login_invalid_credentials_error_key: 'loginInvalidCredentialsErrorKey',
  invalid_session_error_key: 'invalidSessionErrorKey',
  invalid_token_error_key: 'invalidTokenErrorKey',
  not_authenticated_error_key: 'notAuthenticatedErrorKey',
  token_generation_failed_error_key: 'tokenGenerationFailedErrorKey',
  unauthorized_error_key: 'unauthorizedErrorKey',
  invalid_refresh_token_error_key: 'invalidRefreshTokenErrorKey',
  invalid_creation_user_token_error_key: 'invalidCreationUserTokenErrorKey',
  unknown_error_key: 'unknownErrorKey',
  forbidden_permissions_error_key: 'forbiddenPermissionsErrorKey',
  user_not_found_error_key: 'userNotFoundErrorKey',
  password_missing_digit_error_key: 'passwordMissingDigitErrorKey',
  password_missing_uppercase_error_key: 'passwordMissingUpperCaseErrorKey',
  password_missing_lower_case_error_key: 'passwordMissingLowerCaseErrorKey',
  password_missing_special_character_error_key: 'passwordMissingSpecialCharacterErrorKey',
  password_wrong_length_error_key: 'passwordWrongLengthErrorKey',
  invalid_email_error_key: 'invalidEmailErrorKey',
  user_not_allowed_error_key: 'userNotAllowedErrorKey',
  invalid_otp_secret_key: 'invalidOtpSecretKey',
  too_many_otp_attempts_error_key: 'tooManyOtpAttemptsErrorKey',
  otp_not_only_digits_key: 'otpNotOnlyDigitsKey',
  otp_invalid_length_key: 'otpInvalidLengthKey',
  expired_otp_error_key: 'expiredOtpErrorKey',
  user_already_exists_error_key: 'userAlreadyExistsErrorKey',
  role_not_found_error_key: 'roleNotFoundErrorKey',
  user_already_has_password_error_key: 'userAlreadyHasPasswordErrorKey',
  admin_manager_not_found_error_key: 'adminManagerNotFoundErrorKey',
  dam_user_not_found_error_key: 'damUserNotFoundErrorKey',
  user_already_been_anonymized_error_key: 'userAlreadyBeenAnonymizedErrorKey',
  reason_for_anonymization_required_error_key: 'reasonForAnonymizationRequiredErrorKey',
  invalid_sort_field_error_key: 'invalidSortFieldErrorKey',
  file_not_found_error_key: 'fileNotFoundErrorKey',
  total_percentage_assets_error_key: 'totalPercentageAssetsErrorKey',
  mandate_status_error_key: 'mandateStatusErrorKey',
  mandate_name_already_exist_error_key: 'mandateNameAlreadyExistErrorKey',
  percentage_must_be_number_error_key : 'percentageMustBeNumberErrorKey',
  mandate_not_found_exist_error_key: 'mandateNotFoundErrorKey',
  mandate_not_found_error_key: 'mandateNotFoundErrorKey',
  admin_expense_management_not_found_exist_error_key: 'adminExpenseManagementNotFoundErrorKey',
  mandate_document_not_found_exist_error_key: 'mandateDocumentNotFoundErrorKey',
  platform_fees_not_found_error_key: 'platformFeesNotFoundErrorKey',
  mandate_document_duplicate_error_key: 'mandateDocumentDuplicateErrorKey',
  user_has_active_mandates_error_key: 'userHasActiveMandatesErrorKey',
  user_has_active_subscriptions_error_key: 'userHasActiveSubscriptionsErrorKey',
  kyc_not_found_error_key: 'kycNotFoundErrorKey',
  user_has_pending_contract_error_key: "userHasPendingContractsErrorKey",
  order_amount_negative_error_key: "orderAmountNegativeErrorKey",
  user_has_pending_withdrawals_error_key: "userHasPendingWithdrawalsErrorKey",
  custody_mandate_update_error_key: "custodyMandateUpdateErrorKey",
  aplo_unauthorized_error_key: "aploUnauthorizedErrorKey",
  instrument_not_found_error_key: "instrumentNotFoundErrorKey",
  not_enough_funds_error_key: "notEnoughFundsErrorKey",
  asset_not_in_universe_error_key: "assetNotInUniverseErrorKey",
  limit_price_negative_error_key: "limitPriceNegativeErrorKey",
  status_not_found_error_key: "statusNotFoundErrorKey",
  mandate_withdrawal_not_found_error_key: "mandateWithdrawalNotFoundErrorKey",
  user_bank_account_not_found_error_key: "userBankAccountNotFoundErrorKey",
  withdrawal_refusal_reason_required_error_key: "withdrawalRefusalReasonRequiredErrorKey",
  mandate_investment_range_error_key: "mandateInvestmentRangeErrorKey",
  mandate_document_invalid_type_error_key: "mandateDocumentInvalidTypeErrorKey",
  trading_api_key_not_found_error_key: "tradingApiKeyNotFoundErrorKey",
  period_values_error_key: "periodValuesErrorKey",
  pending_user_subscription_not_found_error_key: "pendingUserSubscriptionNotFoundErrorKey",
  faq_not_found_error_key: "faqNotFoundErrorKey",
  faq_invalid_content_error_key: "faqInvalidContentErrorKey",
  faq_reorder_invalid_error_key: "faqReorderInvalidErrorKey",
  identity_duplicate_review_not_open_error_key: "identityDuplicateReviewNotOpenErrorKey",
  referral_reward_not_found_error_key: "referralRewardNotFoundErrorKey",
  referral_reward_invalid_status_error_key: "referralRewardInvalidStatusErrorKey",
  referral_reward_not_retryable_error_key: "referralRewardNotRetryableErrorKey",
  referral_reward_not_resolvable_error_key: "referralRewardNotResolvableErrorKey",
};

export default responseConstant;
